import { Dialog as BaseDialog } from "@base-ui/react/dialog";
import type { ReactNode } from "react";
import { IconButton } from "../IconButton/IconButton";
import styles from "./Drawer.module.css";

export interface DrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Labels the panel; shown as its heading unless hideTitle. */
  title: ReactNode;
  hideTitle?: boolean;
  /** Edge the panel slides from. */
  side?: "start" | "end";
  /** Width: sm fits the navigation, md a detail panel, lg wide tables and charts; full width on phones. */
  size?: "sm" | "md" | "lg";
  children: ReactNode;
}

/** A modal side panel (Base UI Dialog): navigation on small screens, detail panels on tablets. */
export function Drawer({
  open,
  onOpenChange,
  title,
  hideTitle = false,
  side = "start",
  size = "sm",
  children,
}: DrawerProps) {
  return (
    <BaseDialog.Root open={open} onOpenChange={(next) => onOpenChange(next)}>
      <BaseDialog.Portal>
        <BaseDialog.Backdrop className={styles.backdrop} />
        <BaseDialog.Popup
          className={styles.panel}
          data-side={side}
          data-size={size}
          initialFocus={(openType) => openType !== "touch"}
        >
          <header className={styles.header} data-hidden-title={hideTitle || undefined}>
            <BaseDialog.Title className={hideTitle ? styles.hiddenTitle : styles.title}>{title}</BaseDialog.Title>
            <BaseDialog.Close render={<IconButton icon="x" label="Close" tooltip={false} size="sm" />} />
          </header>
          <div className={styles.body}>{children}</div>
        </BaseDialog.Popup>
      </BaseDialog.Portal>
    </BaseDialog.Root>
  );
}
